import { FormHelperText, TextField, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ChangeEvent, FC } from 'react';
import { useDictionary, useIsDesktop } from 'Hooks';
import { illegalChars } from 'Regex';
export interface INoteTextField {
  value: string;
  onChange: (value: string) => void;
  error: boolean;
  title?: string;
}

const MAX_LENGTH = 500;

export const NoteTextField: FC<INoteTextField> = ({
  value,
  onChange,
  error,
  title,
}) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const isDesktop = useIsDesktop();

  return (
    <>
      <Typography variant={'body1'} component='label' htmlFor='request-note'>
        {title || dictionary.uploadFile.note}
      </Typography>
      <TextField
        id='request-note'
        aria-describedby={error ? 'request-note-error' : undefined}
        multiline
        rows={4}
        variant='outlined'
        placeholder={dictionary.uploadFile.notePlaceholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onInput={(e: ChangeEvent<HTMLInputElement>) => {
          e.target.value = e.target.value.replace(illegalChars, '');
        }}
        inputProps={{
          maxLength: MAX_LENGTH,
        }}
        error={error}
        helperText={`${value.length}/${MAX_LENGTH}`}
        fullWidth
        margin='normal'
        required
        InputProps={{
          style: {
            background: '#fff',
            border: error ? '1px solid #ec0000' : '1px solid #B7CCFF',
            borderRadius: '8px',
          },
          'aria-describedby': undefined,
        }}
        FormHelperTextProps={{
          style: {
            color: error ? '#ec0000' : '#A020FF',
            textAlign: 'left',
            fontWeight: value.length === MAX_LENGTH ? 'bold' : undefined,
          },
          'aria-hidden': true,
        }}
        sx={{
          '& .MuiInputBase-input': {
            zIndex: 9,
          },
          '& .MuiFormHelperText-root': {
            position: 'relative',
            top: isDesktop ? '-40px' : '-30px',
            fontSize: isDesktop ? '18px' : '14px',
            zIndex: 0,
          },
          '.MuiOutlinedInput-notchedOutline': { border: 'none' },
        }}
      />
      {error && (
        <FormHelperText
          role='alert'
          error={error}
          id={'request-note-error'}
          sx={{ m: '-38px 0 18px', fontSize: '14px' }}
        >
          {dictionary.uploadFile.noteErrorMsg}
        </FormHelperText>
      )}
    </>
  );
};
